// extracted by mini-css-extract-plugin
export default {"leftBlock":"desktop-module__leftBlock--w4Fyp","rightBlock":"desktop-module__rightBlock--Fi38Z"};